import Joi from 'joi'

const LandingPagePasswordUpdated = Joi.object()
    .keys({})
    .description('Password Updated fires any time an end user updates his/her password.')
    .meta({ name: 'LandingPagePasswordUpdated', filename: 'landing_page:password_updated.model' })

export default LandingPagePasswordUpdated
